<!--开通企业云官网 让更多企业的价值被发现-->
<template>
  <div class="open-cloud">
    <div class="span1 SourceHanSansCN">开通企业云官网</div>
    <div class="span2">让更多企业的价值被发现</div>
    <el-button class="default-button" @click="opening">立即开通</el-button>
  </div>
</template>

<script>
export default {
  name: "openCloud",
  data(){
    return{
      CustomInfo:{},
    }
  },
  methods: {
    opening() {
      if (JSON.stringify(this.CustomInfo)=='{}'){
        this.$alert('您还没有登录,是否进行登录', {
          confirmButtonText: '确定',
          callback: action => {
            this.$router.replace({
              path: '/login'
            })
          }
        })
      }else{
        let routeData = this.$router.resolve({
          name: "enterpriseCertification",
          path: '/officialCloud/enterpriseCertification',
        });
        window.open(routeData.href, '_blank')
      }
    }
  },
  beforeMount() {
    this.CustomInfo = sessionStorage.getItem('CustomInfo') ? JSON.parse(sessionStorage.getItem('CustomInfo')) : {};
  }
}
</script>

<style scoped lang="scss">
.open-cloud {
  background: url("~@/assets/img/home/background1.png") no-repeat;
  background-size: 100% 100%;
  width: auto;
  height: 200px;
  text-align: center;

  .span1 {
    font-size: 1.375rem;
    color: #ffffff;
    padding-top: 2.8125rem;
    font-style: italic;
  }

  .span2 {
    color: #ffffff;
    font-size: 16px;
    padding-top: 10px;
  }

  .default-button {
    font-size: 16px;
    font-weight: 500;
    color: #162796;
    padding: 10px 30px;
    margin-top: 30px;
  }
}
</style>